import moment from "moment-timezone"

import { formatWithTimezoneFunc } from "./types/IDateTimeFormatter"

export const formatWithTimezone: formatWithTimezoneFunc = ({
                                                             date,
                                                             zone,
                                                             locale = "en-GB",
                                                             format = "L LT"
                                                           }): string => {
  try {
    if (!date) throw new Error("No date provided")
    if (!zone) throw new Error("No zone provided")

    return moment.utc((moment.utc(date).unix() + moment.tz(date, zone).utcOffset() * 60) * 1000).locale(locale).format(format)

  } catch (error) {
    console.error(error)
    return moment().toISOString()
  }
}
